/**
 * Ensures API payloads always include a string for `description` so omitted/undefined
 * does not serialize to missing JSON keys (backend NOT NULL on `connection.description`).
 */
export function normalizeConnectionDescription(raw: string | null | undefined): string {
  return raw?.trim() ?? '';
}
